import YhDrawer from "@/erp_subpackage/components/YhDrawer";
import { YhForm } from "@/erp_subpackage/components/YhFormBox";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel";
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum";
import { getFormValidatorErrText } from "@/erp_subpackage/utils/util";
import { message } from "antd";
import { debounce } from "lodash";
import React, { useRef } from "react";
import { useTranslation } from 'react-i18next';
import { useWarehouseModel } from "../warehouseModel";

export const AddWarehouseDrawer = () => {
    const { t } = useTranslation();
    const { addWareVisible: visible, shopName, setAddWaerVisible, insertWarehouse } = useWarehouseModel();
    const { getSelectedDictOne, getTreeNodeName } = useDictModel(() => [])
    const formRef = useRef();

    const onCancel = () => {
        setAddWaerVisible(false);
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current.validateFields().then(res => {
            insertWarehouse({
                ...res,
                typeName: getTreeNodeName(res.typeCode)
            }).then(res => {
                res && onCancel()
            })
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const formConfig = {
        formRef,
        formValues: { shopName },
        items: [
            {
                type: "Input",
                fieldLabel: t(`base.view.AddWarehouseDrawer.仓库编码`),
                fieldName: "code",
                span: 24,
            }, {
                type: "Input",
                fieldLabel: t(`base.view.AddWarehouseDrawer.仓库名称`),
                fieldName: "name",
                span: 24,
                rules: [{ required: true, message: t(`base.view.AddWarehouseDrawer.请输入仓库名称`) }]
            }, {
                type: "Select",
                fieldLabel: t(`base.view.AddWarehouseDrawer.仓库类型`),
                fieldName: "typeCode",
                options: getSelectedDictOne(DictCodeEnmu.WAREHOUSE_TYPE),
                rules: [{ required: true, message: t(`base.view.AddWarehouseDrawer.仓库类型`) }],
                span: 24,
            }, {
                type: "Input",
                fieldLabel: t(`base.view.AddWarehouseDrawer.所属机构`),
                fieldName: "shopName",
                span: 24,
                disable: true,
            }, {
                type: "Input",
                fieldLabel: t(`base.view.AddWarehouseDrawer.机构负责人`),
                fieldName: "orgContact",
                span: 24,
            }, {
                type: "Input",
                fieldLabel: t(`base.view.AddWarehouseDrawer.仓库负责人`),
                fieldName: "contact",
                span: 24,
            }, {
                type: "Input",
                fieldLabel: t(`base.view.AddWarehouseDrawer.电话`),
                fieldName: "phone",
                span: 24,
            }, {
                type: "Input",
                fieldLabel: t(`base.view.AddWarehouseDrawer.地址`),
                fieldName: "address",
                span: 24,
            }, {
                type: "Input",
                fieldLabel: t(`base.view.AddWarehouseDrawer.创建时间`),
                fieldName: "createTime",
                span: 24,
                disable: true
            }, {
                type: "Input",
                fieldLabel: t(`base.view.AddWarehouseDrawer.备注`),
                fieldName: "note",
                span: 24,
            }
        ]
    };

    return (
        <YhDrawer
            title= {t(`base.view.AddWarehouseDrawer.仓库新增`)}
            visible={visible}
            onClose={onCancel}
            okText= {t(`base.view.AddWarehouseDrawer.保存`)}
            width={600}
            onOk={debounce(() => { onSubmit() }, 900)}
        >
            <div style={{ padding: "20px 36px" }}><YhForm {...formConfig} /></div>
        </YhDrawer>
    )
}